import type { SimulateSessionResponse } from '@multirx/shared/types/championship.js';
import { DIVISIONS } from '@multirx/shared/types/division.js';
import { labelOwnDriver } from '../auth/ownDriverLabel.js';
import { createPillButton } from '../ui/pillButton.js';
import { buildChampionshipSessionResultsTableRows } from './sessionResultsMarkup.js';

let activeOverlay: HTMLElement | null = null;

function divisionLabel(division: SimulateSessionResponse['completedSession']['division']): string {
  return DIVISIONS.find((d) => d.id === division)?.shortLabel ?? `D${division}`;
}

export function showChampionshipSessionResults(
  response: SimulateSessionResponse,
  onClose?: () => void
): void {
  activeOverlay?.remove();
  activeOverlay = null;

  const winner = response.completedSession.results.find((row) => row.position === 1);
  const overlay = document.createElement('div');
  overlay.className = 'championship-session-results-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Résultats de la course simulée');

  const card = document.createElement('div');
  card.className = 'play-race-results-card championship-session-results-card';

  const title = document.createElement('h2');
  title.className = 'play-race-results-title';
  title.textContent = 'Course simulée';

  const subtitle = document.createElement('p');
  subtitle.className = 'play-race-results-subtitle';
  subtitle.textContent = `${divisionLabel(response.completedSession.division)} — ${
    response.completedSession.label
  }${winner ? ` · Vainqueur : ${labelOwnDriver(winner.driverName, winner.driverId)}` : ''}`;

  const tableWrap = document.createElement('div');
  tableWrap.className = 'play-race-results-table-wrap';
  const table = document.createElement('table');
  table.className = 'play-race-results-table';
  table.innerHTML = `<thead>
    <tr>
      <th scope="col">Pos</th>
      <th scope="col">Pilote</th>
      <th scope="col" class="play-race-results-th--stat" title="Lancers de dé">🎲</th>
      <th scope="col" class="play-race-results-th--stat" title="Dépassements réussis">↑</th>
      <th scope="col" class="play-race-results-th--stat" title="Dépassements contrés">🛡</th>
    </tr>
  </thead>`;
  const tbody = document.createElement('tbody');
  tbody.innerHTML = buildChampionshipSessionResultsTableRows(response.completedSession.results);
  table.appendChild(tbody);
  tableWrap.appendChild(table);

  const actions = document.createElement('div');
  actions.className = 'play-race-results-actions';
  const closeBtn = createPillButton('Continuer', { variant: 'cta', large: true });
  const dismiss = (): void => {
    overlay.remove();
    if (activeOverlay === overlay) activeOverlay = null;
    onClose?.();
    window.location.hash = 'saisons';
  };
  if (closeBtn instanceof HTMLButtonElement) {
    closeBtn.type = 'button';
    closeBtn.onclick = dismiss;
  }
  actions.appendChild(closeBtn);

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) dismiss();
  });

  card.append(title, subtitle, tableWrap, actions);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
  activeOverlay = overlay;
}

export function dismissChampionshipSessionResults(): void {
  activeOverlay?.remove();
  activeOverlay = null;
}
